import useEventCallback from '@unifyapps/hooks/useEventCallback';
import type { OnActionArgs, OnActionType } from '../../../../context/ActionsProvider/context';
import { useGetNoCodeComputedData } from '../../../computeContext/useGetNoCodeComputedData';
import { useScriptLog } from '../../../useScriptLog';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

export type LogToDebuggerPayload = {
  message?: string;
  payload?: unknown;
  level?: string;
};

export const useLogToDebugger = () => {
  const makeLog = useScriptLog();
  const { getNoCodeComputedData } = useGetNoCodeComputedData();

  const onLogToDebugger: OnActionType = useEventCallback(
    ({ action, actionContext, instanceId, blockId }: OnActionArgs) => {
      const { message, payload, level } = (action.payload ?? {}) as LogToDebuggerPayload;
      const computed = getNoCodeComputedData<{ message?: unknown; payload?: unknown }>(
        { message, payload },
        actionContext,
      );
      makeLog(instanceId, blockId)(computed.message ?? '', computed.payload, level);
      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
  );

  return { onLogToDebugger };
};
